import { useEffect } from "react";

export function useSEO(title, description) {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }, [title, description]);
}

export const CATALOGUE_URL = "/sepla-catalogue.pdf";
export const CATALOGUE_SIZE = "PDF, 3.4 MB";

export const WHATSAPP = "919833536564";
export const PHONE = "+91 98335 36564";
export const PHONE_LINK = "tel:+919833536564";
export const EMAIL = "raj.steelenterprises@gmail.com";
export const ADDRESS = "Raj Enterprises, 17 Satyam Industrial Estate, Navghar Cross Road No 5, Bhayandar East, Thane 401105";

export const waLink = (text) => `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}`;
